import { RewriteRule } from "./rewrite-models";

const devApiRegex = /https:\/\/api\.dev\.curantissolutions\.com/;
const proxy8080 = `http://localhost:8100/api8080`;

export function regexConcat(regexes: RegExp[]) {
  return new RegExp(regexes.map((r) => r.source).join(""));
}

export const rewriteRules: Record<string, RewriteRule> = {
  // assessment
  "/addendums/{addendumId}": {
    from: regexConcat([devApiRegex, /\/addendums\/(\d*)\/?/]),
    to: `${proxy8080}/addendums/$1`,
  },
  "/assessment-palliative-billing/{visitId}/reports": {
    from: regexConcat([
      devApiRegex,
      /\/assessment-palliative-billing\/(\d*)\/reports\/?/,
    ]),
    to: `${proxy8080}/assessmentpalliativebilling/$1/reports`,
  },
  "/assessment-palliative/{visitId}/reports": {
    from: regexConcat([
      devApiRegex,
      /\/assessment-palliative\/(\d*)\/reports\/?/,
    ]),
    to: `${proxy8080}/assessmentpalliative/$1/reports`,
  },
  "/assessment/evaluationAssessments/{patientChartId}": {
    from: regexConcat([
      devApiRegex,
      /\/assessment\/evaluationAssessments\/(\d*)\/?/,
    ]),
    to: `${proxy8080}/assessment/evaluationAssessments/$1`,
  },
  "/assessment/initialAndCurrentDetails/{patientChartId}": {
    from: regexConcat([
      devApiRegex,
      /\/assessment\/initialAndCurrentDetails\/(\d*)\/?/,
    ]),
    to: `${proxy8080}/assessment/initialAndCurrentDetails/$1`,
  },
  "/assessmentOffline/assessmentSync": {
    from: regexConcat([devApiRegex, /\/assessmentOffline\/assessmentSync\/?/]),
    to: `${proxy8080}/assessmentSync`,
  },
  "/assessmentOffline/assessmentSyncAudit": {
    from: regexConcat([
      devApiRegex,
      /\/assessmentOffline\/assessmentSyncAudit\/?/,
    ]),
    to: `${proxy8080}/assessmentSyncAudit`,
  },
  "/assessmentOffline/master/calendar": {
    from: regexConcat([
      devApiRegex,
      /\/assessmentOffline\/master\/calendar\/?/,
    ]),
    to: `${proxy8080}/assessmentOffline/master/calendar`,
  },
  "/assessmentOffline/masterData/": {
    from: regexConcat([devApiRegex, /\/assessmentOffline\/masterData\/\/?/]),
    to: `${proxy8080}/assessmentOffline/masterData/`,
  },
  "/changeOrganization/{organizationId}": {
    from: regexConcat([devApiRegex, /\/changeOrganization\/(\d*)\/?/]),
    to: `${proxy8080}/changeOrganization/$1`,
  },
  "/deleteVisit": {
    from: regexConcat([devApiRegex, /\/deleteVisit\/?/]),
    to: `${proxy8080}/deleteVisit`,
  },
  "/employees/{id}/details": {
    from: regexConcat([devApiRegex, /\/employees\/(\d*)\/details\/?/]),
    to: `${proxy8080}/employees/$1/details`,
  },
  "/hqrp/visits/{assessmentId}/his": {
    from: regexConcat([devApiRegex, /\/hqrp\/visits\/(\d*)\/his\/?/]),
    to: `${proxy8080}/hqrp/assessments/$1/his`,
  },
  "/hqrp/visits/{assessmentId}/hope": {
    from: regexConcat([devApiRegex, /\/hqrp\/visits\/(\d*)\/hope\/?/]),
    to: `${proxy8080}/hqrp/assessments/$1/hope`,
  },
  "/patient-chart/{patientChartId}/face-to-face": {
    from: regexConcat([devApiRegex, /\/patient-chart\/(\d*)\/face-to-face\/?/]),
    to: `${proxy8080}/patient-chart/$1/face-to-face`,
  },
  "/patient-charts/visits/{visitId}/visitTimes": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/visits\/(\d*)\/visitTimes\/?/,
    ]),
    to: `${proxy8080}/editVisitTimes/$1`,
  },
  "/patient-charts/{patientChartId}/comprehensive-visit-count": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/(\d*)\/comprehensive-visit-count\/?/,
    ]),
    to: `${proxy8080}/patients/$1/getComprehensiveVisitForCount`,
  },
  "/patient-charts/{patientChartId}/visit-types": {
    from: regexConcat([devApiRegex, /\/patient-charts\/(\d*)\/visit-types\/?/]),
    to: `${proxy8080}/assessment-type?patientChartId=$1`,
  },
  "/patient-charts/{patientChartId}/visits": {
    from: regexConcat([devApiRegex, /\/patient-charts\/(\d*)\/visits\/?/]),
    to: `${proxy8080}/patients/$1/visits`,
  },
  "/patient-charts/{patientChartId}/visits/notes": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/(\d*)\/visits\/notes\/?/,
    ]),
    to: `${proxy8080}/patients/$1/notes`,
  },
  "/patient-charts/{patientChartId}/visits/recent-notes": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/(\d*)\/visits\/recent-notes\/?/,
    ]),
    to: `${proxy8080}/assessment/idg/$1/recent_notes`,
  },
  "/patient-charts/{patientChartId}/visits/{visitId}/history/{cardType}": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/(\d*)\/visits\/(\d*)\/history\/(\w*)\/?/,
    ]),
    to: `${proxy8080}/patient/$1/assessment/$2/history/$3`,
  },
  "/patient-charts/{patientChartId}/visits/{visitId}/voidVisit": {
    from: regexConcat([
      devApiRegex,
      /\/patient-charts\/(\d*)\/visits\/(\d*)\/voidVisit\/?/,
    ]),
    to: `${proxy8080}/assessment/$2/voidVisit`,
  },
  "/patients-charts/{patientChartId}/visitfrequencies": {
    from: regexConcat([
      devApiRegex,
      /\/patients-charts\/(\d*)\/visitfrequencies\/?/,
    ]),
    to: `${proxy8080}/patients/$1/visitfrequencies`,
  },
  "/plan-of-care/{visitId}/reports": {
    from: regexConcat([devApiRegex, /\/plan-of-care\/(\d*)\/reports\/?/]),
    to: `${proxy8080}/planofcare/$1/reports`,
  },
  "/visitfrequencies": {
    from: regexConcat([devApiRegex, /\/visitfrequencies\/?/]),
    to: `${proxy8080}/visitfrequencies`,
  },
  "/visitfrequencies/{id}": {
    from: regexConcat([devApiRegex, /\/visitfrequencies\/(\d*)\/?/]),
    to: `${proxy8080}/visitfrequencies/$1`,
  },
  "/visitfrequencies/{id}/histories": {
    from: regexConcat([devApiRegex, /\/visitfrequencies\/(\d*)\/histories\/?/]),
    to: `${proxy8080}/visitfrequencies/$1/histories`,
  },
  "/visits": {
    from: regexConcat([devApiRegex, /\/visits\/?/]),
    to: `${proxy8080}/assessment`,
  },
  "/visits/cancelReasons": {
    from: regexConcat([devApiRegex, /\/visits\/cancelReasons\/?/]),
    to: `${proxy8080}/assessment/cancelReasons`,
  },
  "/visits/fromCalendar": {
    from: regexConcat([devApiRegex, /\/visits\/fromCalendar\/?/]),
    to: `${proxy8080}/assessment/fromCalendar`,
  },
  "/visits/patientChartId/{patientChartId}/open": {
    from: regexConcat([
      devApiRegex,
      /\/visits\/patientChartId\/(\d*)\/open\/?/,
    ]),
    to: `${proxy8080}/assessment/patientChartId/$1/open`,
  },
  "/visits/template/section/{sectionLookupCode}": {
    from: regexConcat([devApiRegex, /\/visits\/template\/section\/(\d*)\/?/]),
    to: `${proxy8080}/assessment/template/section/$1`,
  },
  "/visits/visitCount": {
    from: regexConcat([devApiRegex, /\/visits\/visitCount\/?/]),
    to: `${proxy8080}/visitCount`,
  },
  "/visits/{visitId}": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/?/]),
    to: `${proxy8080}/assessment/$1`,
  },
  "/visits/{visitId}/addendums": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/addendums\/?/]),
    to: `${proxy8080}/assessments/$1/addendums`,
  },
  "/visits/{visitId}/cancel": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/cancel\/?/]),
    to: `${proxy8080}/assessment/$1/cancel`,
  },
  "/visits/{visitId}/complete": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/complete\/?/]),
    to: `${proxy8080}/assessment/$1/complete`,
  },
  "/visits/{visitId}/completion-status": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/completion-status\/?/]),
    to: `${proxy8080}/assessment/$1/completion_status`,
  },
  "/visits/{visitId}/eFaxReport": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/eFaxReport\/?/]),
    to: `${proxy8080}/assessments/$1/eFaxReport`,
  },
  "/visits/{visitId}/reports": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/reports\/?/]),
    to: `${proxy8080}/assessments/$1/reports`,
  },
  "/visits/{visitId}/sections/{sectionId}": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/sections\/(\d*)\/?/]),
    to: `${proxy8080}/assessment/$1/$2`,
  },
  "/visits/{visitId}/sections/{sectionId}/cards/{card}": {
    from: regexConcat([
      devApiRegex,
      /\/visits\/(\d*)\/sections\/(\d*)\/cards\/(\d*)\/?/,
    ]),
    to: `${proxy8080}/assessment/$1/$2/$3`,
  },
  "/visits/{visitId}/sections/{sectionId}/cards/{card}/{cardId}": {
    from: regexConcat([
      devApiRegex,
      /\/visits\/(\d*)\/sections\/(\d*)\/cards\/(\d*)\/(\d*)\/?/,
    ]),
    to: `${proxy8080}/assessment/$1/$2/$3/$4`,
  },
  "/visits/{visitId}/sections/{sectionId}/updateSnapshot": {
    from: regexConcat([
      devApiRegex,
      /\/visits\/(\d*)\/sections\/(\d*)\/updateSnapshot\/?/,
    ]),
    to: `${proxy8080}/assessment/$1/section/$2/updateSnapshot`,
  },
  "/visits/{visitId}/signatures": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/signatures\/?/]),
    to: `${proxy8080}/assessments/$1/signatures`,
  },
  "/visits/{visitId}/template": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/template\/?/]),
    to: `${proxy8080}/assessment/$1/template`,
  },
  "/visits/{visitId}/template/{sectionType}": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/template\/(\w*)\/?/]),
    to: `${proxy8080}/assessment/$1/template/$2`,
  },
  "/visits/{visitId}/{sectionId}/{cardId}": {
    from: regexConcat([devApiRegex, /\/visits\/(\d*)\/(\d*)\/(\d*)\/?/]),
    to: `${proxy8080}/assessment/$1/$2/$3`,
  },
  "/patient-chart/{patientChartId}/hqrp/{reportType}": {
    from: regexConcat([devApiRegex, /\/patient-chart\/(\d*)\/hqrp\/(\w*)\/?/]),
    to: `${proxy8080}/patient-chart/$1/hqrp/$2`,
  },
};



// WEBPACK FOOTER //
// ./src/providers/custom-http-interceptor/rewrite-rules.ts